"use strict";
exports.__esModule = true;
exports.OfferCurrentEvaluateStep = exports.OfferStates = void 0;
var OfferStates;
(function (OfferStates) {
    OfferStates["INITIATED"] = "Initiated";
    OfferStates["PENDING_ACCEPT"] = "PendingAccept";
    OfferStates["PENDING_EVALUATE"] = "PendingEvaluate";
    OfferStates["DENIED"] = "Denied";
    OfferStates["REJECTED"] = "Rejected";
    OfferStates["ACCEPTED"] = "Accepted";
    OfferStates["CLOSED"] = "Closed";
    OfferStates["WITHDRAWN"] = "Withdrawn";
    OfferStates["EXPIRED"] = "Expired";
})(OfferStates = exports.OfferStates || (exports.OfferStates = {}));
var OfferCurrentEvaluateStep;
(function (OfferCurrentEvaluateStep) {
    OfferCurrentEvaluateStep["VERIFY_INCOME"] = "VerifyIncome";
    OfferCurrentEvaluateStep["IDENTITY_DOCUMENT_VERIFICATION"] = "IdentityDocumentVerification";
})(OfferCurrentEvaluateStep = exports.OfferCurrentEvaluateStep || (exports.OfferCurrentEvaluateStep = {}));
